import { GetStaticProps, NextPage } from 'next';
import { useEffect, useMemo, useState } from 'react';

import DeviceCardPage from '@/views/sensors/overview-page';

const Sensors: NextPage = () => {
  const [fetchTime, setFetchTime] = useState(Date.now());

  useEffect(() => {
    const handle = setTimeout(() => {
      setFetchTime(Date.now());
    }, (5).minutes);

    return () => clearTimeout(handle);
  }, [fetchTime]);

  const timeAtLoad = useMemo(() => {
    return new Date(fetchTime);
  }, [fetchTime]);

  return <DeviceCardPage timeAtLoad={timeAtLoad} />;
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {
    namespaces: ['device'],
  },
});

export default Sensors;
